import { Box, IconButton, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

export function PositionSetEditor(props: {
  currentPositionSet: string;
  onChange: (event: SelectChangeEvent) => void;
  positionSetNames: string[];
  onTryAddPositionSet: (newSetName: string) => void;
  onTryRemovePositionSet: () => void;
  onTryRenamePositionSet: (oldName: string, newName: string) => void;
}) {
  const [addingPositionSet, setAddingPositionSet] = useState(false);
  const [renamingPositionSet, setRenamingPositionSet] = useState(false);
  const [newPositionSetRename, setNewPositionSetRename] = useState("");
  const [newPositionSetName, setNewPositionSetName] = useState("");

  return (
    <>
      <Box>
        {!addingPositionSet && !renamingPositionSet && (
          <>
            <Typography variant="subtitle1">Positions set:&nbsp;</Typography>
            <Box className="horizontal-flex">
              {props.currentPositionSet ? (
                <Select
                  labelId="positions-target-label"
                  id="positions-target"
                  value={props.currentPositionSet}
                  label="Target"
                  onChange={props.onChange}
                >
                  {props.positionSetNames.map((name: string) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              ) : (
                <Typography variant="caption" sx={{ border: "1px solid #ccc", padding: "4px" }}>
                  Empty
                </Typography>
              )}
              {props.currentPositionSet && (
                <IconButton
                  color="primary"
                  aria-label="rename"
                  onClick={() => {
                    setRenamingPositionSet(true);
                    setNewPositionSetRename(props.currentPositionSet);
                  }}
                >
                  <RenameOutlineIcon />
                </IconButton>
              )}
              <IconButton color="primary" aria-label="add" onClick={() => setAddingPositionSet(true)}>
                <AddIcon />
              </IconButton>
              <IconButton
                color="error"
                aria-label="delete"
                onClick={() => {
                  props.onTryRemovePositionSet();
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </>
        )}

        {renamingPositionSet && (
          <>
            <TextField
              id="new-position-set-name"
              label="New position set name"
              autoFocus={true}
              variant="outlined"
              value={newPositionSetRename}
              onChange={(event) => setNewPositionSetRename(event.target.value)}
            />
            <IconButton
              color="primary"
              aria-label="confirm"
              onClick={() => {
                props.onTryRenamePositionSet(props.currentPositionSet, newPositionSetRename);
                setRenamingPositionSet(false);
                setNewPositionSetRename("");
              }}
            >
              <CheckIcon />
            </IconButton>
            <IconButton color="error" aria-label="close" onClick={() => setRenamingPositionSet(false)}>
              <CloseIcon />
            </IconButton>
          </>
        )}

        {addingPositionSet && (
          <>
            <TextField
              id="new-position-set"
              label="New position set"
              autoFocus={true}
              variant="outlined"
              onChange={(event) => setNewPositionSetName(event.target.value)}
            />
            <IconButton
              color="primary"
              aria-label="confirm"
              onClick={() => {
                props.onTryAddPositionSet(newPositionSetName);
                setAddingPositionSet(false);
                setNewPositionSetName("");
              }}
            >
              <CheckIcon />
            </IconButton>
            <IconButton color="error" aria-label="close" onClick={() => setAddingPositionSet(false)}>
              <CloseIcon />
            </IconButton>
          </>
        )}
      </Box>
    </>
  );
}
